import {Component, inject, Input} from "@angular/core";

import {faAngleRight, faChevronRight, faHome, faHouseChimney} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";
import {NavigationExtras, Router, RouterLink} from "@angular/router";

export interface BreadcrumbNavigation {
  text: string,
  route: string,
  queryParams?: NavigationExtras
}
@Component({
    selector: 'breadcrumb',
    imports: [FontAwesomeModule, FormsModule, MatIcon, RouterLink],
    templateUrl: './breadcrumb.html'
})
export class BreadcrumbComponent {
  @Input('navigations') navigations: BreadcrumbNavigation[] = [];
  @Input('endText') endText: string = '';
  faChevronRight = faChevronRight;
  router = inject(Router);

  navToRoute(navRoute: string, queryParams?: NavigationExtras) {
    this.router.navigate([navRoute], queryParams)
  }

  protected readonly faAngleRight = faAngleRight;
  protected readonly faHouseChimney = faHouseChimney;
}
